import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$destinationPlatf;
  var _component_speach_configure_table = _resolveComponent("speach-configure-table");
  return _openBlock(), _createBlock(_component_speach_configure_table, {
    "list-speach": _ctx.listSpeach,
    "destination-platform": (_ctx$destinationPlatf = _ctx.destinationPlatform) === null || _ctx$destinationPlatf === void 0 ? void 0 : _ctx$destinationPlatf.platformID,
    onEmptyCourVisible: _ctx.refreshCourAndAddToList
  }, null, 8, ["list-speach", "destination-platform", "onEmptyCourVisible"]);
}